import {GetTypes} from "../../../../helpers/enum-helpers";

export enum Salutation {
  Male,
  Female,
  Other
}

export const SalutationLabels: { [key in Salutation]: string } = {
  [Salutation.Male]: "Herr",
  [Salutation.Female]: "Frau",
  [Salutation.Other]: "Divers"
}

export const SalutationList: Salutation[] = GetTypes(Salutation).map(x => parseInt(x));
